/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractResponseDto } from '../../models/sales-contract-response-dto';
import { SalesCreateContractDto } from '../../models/sales-create-contract-dto';

export interface ContractsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesCreateContractDto
}

export function contractsControllerCreate(http: HttpClient, rootUrl: string, params: ContractsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractResponseDto>;
    })
  );
}

contractsControllerCreate.PATH = '/o2-sales/contracts/{tenant}';
